export default {
    AGORA_APP_ID : '0603ddb0f1a8448d937de105ffbdfc05',
    
    // AGORA_APP_ID : '01b3cfa98bda4ad6b71e12d03f107d5a',

    SEND_MESSAGE_TYPE : 1,
    RECEIVE_MESSAGE_TYPE : 2,
    INFO_MESSAGE_TYPE : 2,
    
    VIDEO_STARTED : 0,
    VIDEO_RINGING : 1,
    VIDEO_CANCELLED_BY_CALLER : 2,
    VIDEO_CANCELLED_BY_RECEIVER : 3,
    VIDEO_CANCELLED_NOT_RECEIVED : 4,
    VIDEO_PICKED_UP : 5,
    VIDEO_IS_PROGRESS : 6,
    VIDEO_IS_END_BY_CALLER : 7,
    VIDEO_IS_END_BY_RECEIVER : 8,

    DIALLED : 'dialled',
    ENDED : 'ended',
    PICKED_UP : 'picked_up',
    MISSED : 'missed',
    IN_PROGRESS : 'call_in_progress',
    RINGING : 'ringing',
    CANCELLED_BY_CALLER : 'cancelled_by_caller',
    CANCELLED_BY_RECEIVER : 'cancelled_by_receiver',
    ENDED_BY_CONNECTION_PROBLEM : 'ended_by_connection_problem',

    // sendMessageEndPoint: "http://localhost:5001/jpal-b0b71/us-central1/sendMessage",

    sendMessageEndPoint: "https://us-central1-jpal-testing.cloudfunctions.net/sendMessage",
    
    // sendMessageEndPoint: "https://us-central1-jpal-b0b71.cloudfunctions.net/sendMessage",

    callEndPoint: "https://us-central1-jpal-testing.cloudfunctions.net/initiateCall",
    // callEndPoint: "http://localhost:5001/jpal-testing/us-central1/initiateCall",

    // callEndPoint: "http://localhost:5001/jpal-b0b71/us-central1/initiateCall",
    // callEndPoint: "https://us-central1-jpal-b0b71.cloudfunctions.net/initiateCall",

    // eventLogEndPoint: "https://us-central1-jpal-b0b71.cloudfunctions.net/eventLogger",
    eventLogEndPoint: "https://us-central1-jpal-testing.cloudfunctions.net/eventLogger",
    // eventLogEndPoint: "http://localhost:5001/jpal-testing/us-central1/eventLogger",

    eventTypes: {
        join_call: 'join_call',
        initiate_call: 'initiate_call',
        accept_incoming: 'accept_incoming',
        decline_incoming: 'decline_incoming',
        leave_call: 'leave_call'
    }
}